<ng-container [formGroup]="group">
  <div class="form-group" [bs4Class]="['mb-2']" [ngClass]="{'required' : groupName == 'License1' }">
    <label for="input-state" class="control-label">State</label>
    <div class="input-group">
      <select id="input-state" [bs3Class]="['form-control']" [bs4Class]="['form-select']" formControlName="State">
        <option [ngValue]="null"></option>
        <option *ngFor="let state of settings.states" [ngValue]="state">{{ state.sta_name }}</option>
      </select>

      <ng-container *ngIf="group.value.State" bsMigrationPicker [bs3]="stateLookupBs3" [bs4]="stateLookup">
        <ng-template #stateLookup>
          <button bsMigration target="_blank" class="btn btn-default" [href]="'#' + groupName + '-state-regulation'"
            [appColorbox]="{ inline: true, width: 600, height: 400 }">
            <fa-icon [icon]="faCircleInfo"></fa-icon>
            Requirements
          </button>
        </ng-template>
        <ng-template #stateLookupBs3>
          <span class="input-group-btn">
            <ng-container *ngTemplateOutlet="stateLookup"></ng-container>
          </span>

        </ng-template>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="group.value.State">
    <ng-container *ngIf="!isExempt; else exempt">
      <div class="form-group" [bs4Class]="['mb-2']"
        [class.has-error]="HasRawError | async"
        [class.required]="group.controls.Raw.enabled">
        <label for="input-license" class="control-label">License Number</label>
        <div class="input-group" [class.has-validation]="HasRawError | async">
          <div bsMigration class="input-group-addon">{{ group.value.State?.prefix }}</div>
          <input type="text"[class.is-invalid]="HasRawError | async" class="form-control" id="input-license" formControlName="Raw" placeholder="license number"
            [readonly]="Disabled$ | async">
          <ng-container bsMigrationPicker [bs3]="licenseLookupBs3" [bs4]="licenseLookup">
            <ng-template #licenseLookup>
              <button bsMigration target="_blank" class="btn btn-default" [href]="UrlBase + 'state-license-credentials'"
                [appColorbox]="{ width: 800, height: 600 }">
                <fa-icon [icon]="faMagnifyingGlass"></fa-icon> Lookup
              </button>
              <ng-container bsMigrationPicker [bs4]="rawErrors"></ng-container>
            </ng-template>
            <ng-template #licenseLookupBs3>
              <span class="input-group-btn">
                <ng-container *ngTemplateOutlet="licenseLookup"></ng-container>
              </span>
            </ng-template>
          </ng-container>
        </div>
        <ng-template #rawErrors>
          <p *ngIf="group.controls.Raw.invalid" [bs4Class]="['my-0','invalid-feedback']" class="help-block"><strong>License Number</strong> is required.</p>
        </ng-template>
        <ng-container bsMigrationPicker [bs3]="rawErrors"></ng-container>
      </div>

      <div class="form-group" [bs4Class]="['mb-2']" [class.has-error]="HasExpireError | async"
        [class.required]="group.controls.Expire.enabled">
        <label for="input-expiration" class="control-label">Expiration Date</label>
        <div class="input-group" [class.has-validation]="HasExpireError | async">
          <input type="text" bsDatepicker [class.is-invalid]="HasExpireError | async" class="form-control"
            id="input-expiration" formControlName="Expire" placeholder="mm/dd/yyyy" [readonly]="Disabled$ | async">

          <ng-container bsMigrationPicker [bs3]="expirationLookupBs3" [bs4]="expirationLookup">
            <ng-template #expirationLookup>
              <button bsMigration target="_blank" class="btn btn-default" [href]="UrlBase + 'state-license-credentials'"
                [appColorbox]="{ width: 800, height: 600 }">
                <fa-icon [icon]="faMagnifyingGlass"></fa-icon> Lookup
              </button>
              <ng-container bsMigrationPicker [bs4]="expireErrors"></ng-container>
            </ng-template>
            <ng-template #expirationLookupBs3>
              <span class="input-group-btn">
                <ng-container *ngTemplateOutlet="expirationLookup"></ng-container>
              </span>
            </ng-template>
          </ng-container>
        </div>
        <ng-template #expireErrors>
          <p *ngIf="(HasExpireError | async) == 'required'" [bs4Class]="['my-0','invalid-feedback']" class="help-block">
            <strong>Expiration Date</strong> is required.
          </p>
          <ng-container *ngIf="isExpired && ! (Disabled$ | async)">
            <p [bs4Class]="['my-0','invalid-feedback']" class="help-block">
              <strong>Expiration Date</strong> is in the past.
            </p>
            <p [bs4Class]="['my-0','invalid-feedback']" class="help-block">
              Please update our records with your current license expiration date for verification of state compliance and valid insurance.</p>
          </ng-container>
        </ng-template>
        <ng-container bsMigrationPicker [bs3]="expireErrors"></ng-container>
      </div>

      <div *ngIf="Asn === 'ABMP'" bsMigration class="checkbox form-group-sm">
        <label class="control-label" tooltip="Based on my type of practice, I am exempt from state licensing."
          placement="bottom">
          <input [bs4Class]="['form-check-input']" type="checkbox" formControlName="Exempt" [value]="true">
          I am exempt from state licensing
        </label>
        <sup class="text-info" tooltip="Based on my type of practice, I am exempt from state licensing."
          placement="bottom"><strong>?</strong></sup>
        <p class="help-block sr-only">Based on my type of practice, I am exempt from state licensing.</p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<!-- Has to be outside formGroup because of ngModel -->
<ng-container *ngIf="group.value.State">
  <ng-container *ngIf="!isExempt">
    <div bsMigration class="checkbox form-group-sm" *ngIf="!group.value.Exempt">
      <label class="control-label">
        <input [bs4Class]="['form-check-input']" type="checkbox" [(ngModel)]="Skip" (change)="SkipChange($event)"
          [value]="true" [disabled]="!group.value.State">
        I am required to have liability insurance before applying
      </label>
    </div>
    <div class="form-group-sm" *ngIf="showClear && !Skip">
      <p><a (click)="Clear($event)" href="#no-second-license"><strong>Remove this license. </strong> I do not have a
          second license.</a></p>
    </div>
  </ng-container>
</ng-container>

<alert type="warning" *ngIf="Skip">
  <p>Your liability insurance may not be valid until you receive your state license.</p>
  <p>Please contact us at {{ settings.site_phone }} or email <a [href]="'mailto:' + settings.site_mail">{{
      settings.site_mail }}</a> for more information.</p>
</alert>

<div class="hidden">
  <aside [id]="groupName + '-state-regulation'" *ngIf="(regulation | async) as term" [innerHTML]="term.description">
  </aside>
</div>

<ng-template #exempt>
  <p class="help-block">Your state does not require a license.</p>
</ng-template>